// Plain SVG icons for the admin panel – no MUI dependency.
// Paths follow Lucide-style geometry (MIT).

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function SvgIcon({ children, className, size, ...rest }) {
  return (
    <svg
      width={size || '1em'}
      height={size || '1em'}
      viewBox="0 0 24 24"
      aria-hidden
      className={className}
      {...rest}
    >
      {children}
    </svg>
  );
}

export function DashboardIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="3" width="7" height="7" rx="1.5" {...stroke} />
      <rect x="14" y="3" width="7" height="7" rx="1.5" {...stroke} />
      <rect x="14" y="14" width="7" height="7" rx="1.5" {...stroke} />
      <rect x="3" y="14" width="7" height="7" rx="1.5" {...stroke} />
    </SvgIcon>
  );
}

export function ChatIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" {...stroke} />
    </SvgIcon>
  );
}

export function SettingsIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="3" {...stroke} />
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.6.86 1 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
        {...stroke}
      />
    </SvgIcon>
  );
}

export function LogoutIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" {...stroke} />
      <polyline points="16 17 21 12 16 7" {...stroke} />
      <path d="M21 12H9" {...stroke} />
    </SvgIcon>
  );
}

export function PeopleIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...stroke} />
      <circle cx="9" cy="7" r="4" {...stroke} />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" {...stroke} />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" {...stroke} />
    </SvgIcon>
  );
}

export function ImpersonateIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="8" r="4" {...stroke} />
      <path d="M4 20a8 8 0 0 1 16 0" {...stroke} />
    </SvgIcon>
  );
}

export function AdminIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" {...stroke} />
      <path d="M9.5 12.5 11 14l3.5-3.5" {...stroke} />
    </SvgIcon>
  );
}

export function DemoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8 2v4" {...stroke} />
      <path d="M16 2v4" {...stroke} />
      <rect x="3" y="4" width="18" height="18" rx="2" {...stroke} />
      <path d="M3 10h18" {...stroke} />
    </SvgIcon>
  );
}

export function ContactIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" {...stroke} />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" {...stroke} />
    </SvgIcon>
  );
}

export function PersonIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="8" r="4" {...stroke} />
      <path d="M4 20a8 8 0 0 1 16 0" {...stroke} />
    </SvgIcon>
  );
}

export function SecurityIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" {...stroke} />
    </SvgIcon>
  );
}

export function BusinessIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 21h18" {...stroke} />
      <path d="M5 21V7l7-4 7 4v14" {...stroke} />
      <path d="M9 21v-6h6v6" {...stroke} />
      <path d="M9 9h.01" {...stroke} />
      <path d="M15 9h.01" {...stroke} />
      <path d="M9 13h.01" {...stroke} />
      <path d="M15 13h.01" {...stroke} />
    </SvgIcon>
  );
}

export function CorporateFareIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="3" width="8" height="18" rx="1" {...stroke} />
      <rect x="13" y="8" width="8" height="13" rx="1" {...stroke} />
      <path d="M6 7h2" {...stroke} />
      <path d="M6 11h2" {...stroke} />
      <path d="M6 15h2" {...stroke} />
      <path d="M16 12h2" {...stroke} />
      <path d="M16 16h2" {...stroke} />
    </SvgIcon>
  );
}

export function AssessmentIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 3v18h18" {...stroke} />
      <path d="M7 16v-5" {...stroke} />
      <path d="M12 16V8" {...stroke} />
      <path d="M17 16v-8" {...stroke} />
    </SvgIcon>
  );
}

export function CloseIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18 6 6 18" {...stroke} />
      <path d="m6 6 12 12" {...stroke} />
    </SvgIcon>
  );
}

export function PhoneIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
        {...stroke}
      />
    </SvgIcon>
  );
}

export function EmailIcon(props) {
  return <ContactIcon {...props} />;
}

export function CalendarIcon(props) {
  return <DemoIcon {...props} />;
}

export function AccountIcon(props) {
  return <ImpersonateIcon {...props} />;
}

export function InventoryIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="m16.5 9.4-9-5.19" {...stroke} />
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" {...stroke} />
      <path d="M3.27 6.96 12 12.01l8.73-5.05" {...stroke} />
      <path d="M12 22.08V12" {...stroke} />
    </SvgIcon>
  );
}

export function CheckIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="10" {...stroke} />
      <path d="m9 12 2 2 4-4" {...stroke} />
    </SvgIcon>
  );
}

export function UncheckedIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="10" {...stroke} />
    </SvgIcon>
  );
}

export function CommentIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z" {...stroke} />
    </SvgIcon>
  );
}

export function SendIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="m22 2-7 20-4-9-9-4z" {...stroke} />
      <path d="M22 2 11 13" {...stroke} />
    </SvgIcon>
  );
}

export function DeleteIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 6h18" {...stroke} />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" {...stroke} />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" {...stroke} />
      <path d="M10 11v6" {...stroke} />
      <path d="M14 11v6" {...stroke} />
    </SvgIcon>
  );
}

export function EditIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 20h9" {...stroke} />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" {...stroke} />
    </SvgIcon>
  );
}

export function SaveIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" {...stroke} />
      <path d="M17 21v-8H7v8" {...stroke} />
      <path d="M7 3v5h8" {...stroke} />
    </SvgIcon>
  );
}

export function CancelIcon(props) {
  return <CloseIcon {...props} />;
}
